const SCAN_LENGTH = 512;

const startsWith = (bytes: Uint8Array, prefix: number[]): boolean => {
  if (bytes.length < prefix.length) return false;

  for (let i = 0; i < prefix.length; i++) {
    if (bytes[i] !== prefix[i]) return false;
  }

  return true;
};

const IMAGE_PREFIXES = [
  [0x89, 0x50, 0x4e, 0x47], // PNG
  [0xff, 0xd8, 0xff], // JPEG
  [0x47, 0x49, 0x46, 0x38, 0x37, 0x61], // GIF87a
  [0x47, 0x49, 0x46, 0x38, 0x39, 0x61], // GIF89a
];

const PDF_PREFIX = [0x25, 0x50, 0x44, 0x46]; // %PDF
const ARCHIVE_PREFIXES = [
  [0x50, 0x4b, 0x03, 0x04], // ZIP
  [0x1f, 0x8b], // GZIP
];

const hasKnownBinaryPrefix = (bytes: Uint8Array): boolean =>
  IMAGE_PREFIXES.some((prefix) => startsWith(bytes, prefix)) ||
  startsWith(bytes, PDF_PREFIX) ||
  ARCHIVE_PREFIXES.some((prefix) => startsWith(bytes, prefix));

export const isBinaryBytes = (bytes: Uint8Array): boolean => {
  if (hasKnownBinaryPrefix(bytes)) return true;

  const length = Math.min(bytes.length, SCAN_LENGTH);

  for (let i = 0; i < length; i++) {
    if (bytes[i] === 0) {
      return true;
    }
  }

  return false;
};

export const getBinaryFileType = (bytes: Uint8Array): string => {
  if (IMAGE_PREFIXES.some((prefix) => startsWith(bytes, prefix))) {
    return "Image";
  }

  if (startsWith(bytes, PDF_PREFIX)) {
    return "PDF document";
  }

  if (ARCHIVE_PREFIXES.some((prefix) => startsWith(bytes, prefix))) {
    return "Archive";
  }

  return "Binary file";
};
